import { memo } from "react";
import { makeDeliverySettingsAvailable } from "@/data/DeliverySettingsHub.ts";
import { makeOnlineProviderAvailable } from "@/data/OnlineProviderHub.ts";
import SetShippingFeesPlugin from "@delivery-management/SetShippingFees/SetShippingFeesPlugin.tsx";
import GoogleMapsProvider from "@/react/core/GoogleMapsProvider.tsx";

const SetShippingFeesView = () => {
  makeDeliverySettingsAvailable()
  makeOnlineProviderAvailable()

  return (
    <GoogleMapsProvider>
      <SetShippingFeesPlugin />
    </GoogleMapsProvider>
  )
}

export default memo(SetShippingFeesView);